import { gql } from '@apollo/client';

// This is a GraphQL fragment that defines the fields of an Inspection
export const INSPECTION_FIELDS = gql`
   fragment InspectionFields on Inspection {
      id
      inspectionStatus
      scheduledDate
      scheduledTime
      applicationType
      findings {
         result
         observations
         recommendations
         attachments {
            filename
            contentType
            data
         }
         ptprFindings {
            octTctNumber
            lotNumber
            barangay
            municipality
            province
            totalLotArea
            areaDevotedToPlantation
            spacing
            treeSpeciesPlanted
            datePlanted
         }
         covFindings {
            kind
            species
            scientificName
            numberOfTrees
            quantity {
               value
               unit
            }
            volume {
               cubicMeters
               boardFeet
            }
            conveyance
            consignee
         }
         pltpFindings {
            treeInventory {
               species
               scientificName
               numberOfTreesInventoried
               grossVolume
               netVolume
               treeStatus
            }
            totalTrees
            totalGrossVolume
            totalNetVolume
            lotNumber
            octNumber
         }
         pltcpFindings {
            treeInventory {
               species
               scientificName
               numberOfTreesInventoried
               grossVolume
               netVolume
               treeCategory
            }
            totalTrees
            totalGrossVolume
            totalNetVolume
         }
         tcebpFindings {
            treeInventory {
               species
               numberOfTreesInventoried
               status
               treeCategory
               grossVolume
               netVolume
            }
            totalTrees
            totalGrossVolume
            totalNetVolume
         }
      }
   }
`;
